import { IDeleteNoteboardImageNodeInput, INoteboardImageNode } from "@schemas/issueBoardSchema";
import { AppDispatch } from "../../../store";
import { IIssueBoardParams, issueBoardRTK } from "./IssueBoardRTK";

type ServerNoteboardImageNode = INoteboardImageNode & Record<string, unknown>;

export function upsertNoteboardImageNode(
  dispatch: AppDispatch,
  params: IIssueBoardParams,
  node: ServerNoteboardImageNode,
) {
  return dispatch(
    issueBoardRTK.util.updateQueryData("getSingleIssueBoard", params, (draft) => {
      if (!Array.isArray(draft.noteboardImageNodes)) draft.noteboardImageNodes = [];
      const idx = draft.noteboardImageNodes.findIndex((n) => n._id === node._id);
      if (idx >= 0) {
        draft.noteboardImageNodes[idx] = {
          ...(draft.noteboardImageNodes[idx] as any),
          ...(node as any),
        };
      } else {
        draft.noteboardImageNodes.push(node as any);
      }
    }),
  );
}

export type UndoFn = () => void;

/**
 * - Utan serverBoard => OPTIMISTISK patch (ta bort noden i cache).
 * - Med serverBoard  => RECONCILE (synka hela boardet till serversvaret).
 * Returnerar undo-funktion för den optimistiska patchen (om sådan gjordes).
 */
export function patchNoteboardImageNodesAfterDelete(
  dispatch: AppDispatch,
  args: IDeleteNoteboardImageNodeInput,
): UndoFn | undefined {
  const { projectId, issueBoardId, noteboardImageNodeId } = args;

  const patchResult = dispatch(
    issueBoardRTK.util.updateQueryData("getSingleIssueBoard", { projectId, issueBoardId }, (draft) => {
      console.log(draft);
      if (!draft?.noteboardImageNodes) return;

      draft.noteboardImageNodes = draft.noteboardImageNodes.filter((n) => n._id !== noteboardImageNodeId);
    }),
  );

  return patchResult.undo;
}
